import { render, staticRenderFns } from "./OsobaDetails.vue?vue&type=template&id=12461292&scoped=true&"
import script from "./OsobaDetails.vue?vue&type=script&lang=js&"
export * from "./OsobaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12461292",
  null
  
)

export default component.exports